module.exports = __webpack_public_path__ + "static/media/Explore.d0bfa838.svg";